import { gql } from 'apollo-boost';

export const GROUPS_QUERY = gql`
    query groups {
        groups {
            totalCount
            edges {
                node {
                    id
                    name
                    type
                    attributes {
                        id
                        dataFormat
                        dataType
                        name
                        value
                    }
                    __typename
                }
                __typename
            }
            __typename
        }
    }
`;
